$(function() {
  var $frame = $('.hero-image__slider-container');
  var $wrap  = $frame.parent();

  // Call Sly on frame
  var slyder = $frame.sly({
    horizontal: 1,
    itemNav: 'forceCentered',
    smart: 1,
    activateMiddle: 1,
    activatePageOn: 'click',
    mouseDragging: 1,
    touchDragging: 1,
    releaseSwing: 1,
    startAt: 1,
    scrollBy: 1,
    speed: 300,
    elasticBounds: 1,
    dragHandle: 1,
    dynamicHandle: 1,
    clickBar: 1,

    pagesBar: $wrap.find('.hero-image__slider-pages'),
  });

  $(window).smartresize(function(){
    if (slyder != null) {
      slyder.sly('reload');  
    }
  });
});
